module.exports = __webpack_public_path__ + "static/media/david-metcalfe.2cbf7ee7.jpg";